import styled from 'styled-components';

/** @deprecated use Stack instead */
export const FlexSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
    flex: 1;
`;

/** @deprecated use Stack instead */
export const FlexSpaceBetweenAlignCenter = styled(FlexSpaceBetween)`
    align-items: center;
`;

/** @deprecated use Stack instead */
export const FlexAlignCenter = styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
`;

/** @deprecated use StackItem instead */
export const FlexItemFlexible = styled.div`
    flex: 1 1;
`;

/** @deprecated use StackItem instead */
export const FlexItemNoShrink = styled.div`
    flex-shrink: 0;
`;
